interface ValidateHttpUrlOptions {
  baseUrl?: string;
  allowedProtocols?: readonly string[];
}

const DEFAULT_ALLOWED_PROTOCOLS: readonly string[] = ['http:', 'https:'];

export const validateHttpUrl = (
  url: string | null | undefined,
  options: ValidateHttpUrlOptions = {},
): string | undefined => {
  if (!url) {
    return undefined;
  }

  const { baseUrl, allowedProtocols = DEFAULT_ALLOWED_PROTOCOLS } = options;

  try {
    const parsedUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    return allowedProtocols.includes(parsedUrl.protocol) ? parsedUrl.toString() : undefined;
  } catch {
    return undefined;
  }
};
